module.exports = "pegasus_template/assets/themelp1/travel/100.png";